import Konva from "konva"
import {
    Lifecycle,
    LifecyclePhase,
    LifecycleConnection,
} from "server/models"
import { OrderType, StateType } from "client/utils"

export type LifecycleOnSelectPhase = (phase: LifecyclePhase) => void

export interface LifecycleProps {
    lifecycleId: number
    hash?: string
}

export type LifecycleValidation = { [key in keyof Lifecycle]?: string}
export type LifecyclePhaseValidation = { [key in keyof LifecyclePhase]?: string}

export interface LifecycleList { [lifecycleId: number]: Lifecycle }
export interface LifecyclePhaseList { [phaseId: number]: LifecyclePhase }

export interface NestedPhase {
    phase: LifecyclePhase
    phases: readonly NestedPhase[]
    connections: readonly LifecycleConnection[]
}

export interface ImportLifecyclePhasesType {
    nestedPhase: NestedPhase
    newLifecycleId: number
}

export interface LifecycleImportFilters {
    search?: string
}


export interface LifecycleState {
    lifecyclePath: readonly LifecyclePhase[]
    baseRoute: string
    onSelectPhase: LifecycleOnSelectPhase

    lifecycleList: LifecycleList
    lifecycleIds: readonly number[]
    lifecycleView: Lifecycle
    lifecycleEdit: Lifecycle

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean

    model: {
        phaseList: readonly LifecyclePhase[]
        activePhase: LifecyclePhase
        confirmDeletePhase: LifecyclePhase
        reloadActivePhase: boolean

        connectionList: readonly LifecycleConnection[]
        activeConnection: LifecycleConnection
        confirmDeleteConnection: LifecycleConnection
        reloadActiveConnection: boolean

        dragPhase: Konva.Node
        drawConnection: LifecycleConnection
        loadState: StateType
        reloadModel: boolean
    }

    // import
    importFromLibrary: {
        lifecycleList: LifecycleList
        lifecycleIds: readonly number[]
        sortColumn: keyof Lifecycle
        sortOrder: OrderType
        filters: LifecycleImportFilters
    }

    importFromAccount: {
        lifecycleList: LifecycleList
        lifecycleIds: readonly number[]
        sortColumn: keyof Lifecycle
        sortOrder: OrderType
        filters: LifecycleImportFilters
    }

    importLifecycleId: number
    reloadImported: boolean
}

// lifecycle
export const LIFECYCLE_PATH = "LIFECYCLE_PATH"
export const LIFECYCLE_BASE_ROUTE = "LIFECYCLE_BASE_ROUTE"
export const LIFECYCLE_ON_SELECT_PHASE = "LIFECYCLE_ON_SELECT_PHASE"

export const LIFECYCLE_LIST = "LIFECYCLE_LIST"
export const LIFECYCLE_IDS = "LIFECYCLE_IDS"
export const LIFECYCLE_VIEW = "LIFECYCLE_VIEW"
export const LIFECYCLE_EDIT = "LIFECYCLE_EDIT"

export const LIFECYCLE_RELOAD_LIST = "LIFECYCLE_RELOAD_LIST"
export const LIFECYCLE_RELOAD_VIEW = "LIFECYCLE_RELOAD_VIEW"
export const LIFECYCLE_RELOAD_EDIT = "LIFECYCLE_RELOAD_EDIT"


// lifecycle model
export const LIFECYCLE_PHASE_LIST = "LIFECYCLE_PHASE_LIST"
export const LIFECYCLE_PHASE_ACTIVE = "LIFECYCLE_PHASE_ACTIVE"
export const LIFECYCLE_PHASE_CONFIRM_DELETE = "LIFECYCLE_PHASE_CONFIRM_DELETE"
export const LIFECYCLE_PHASE_RELOAD_ACTIVE = "LIFECYCLE_PHASE_RELOAD_ACTIVE"

export const LIFECYCLE_CONNECTION_LIST = "LIFECYCLE_CONNECTION_LIST"
export const LIFECYCLE_CONNECTION_ACTIVE = "LIFECYCLE_CONNECTION_ACTIVE"
export const LIFECYCLE_CONNECTION_CONFIRM_DELETE = "LIFECYCLE_CONNECTION_CONFIRM_DELETE"
export const LIFECYCLE_CONNECTION_RELOAD_ACTIVE = "LIFECYCLE_CONNECTION_RELOAD_ACTIVE"

export const LIFECYCLE_MODEL_DRAG_PHASE = "LIFECYCLE_MODEL_DRAG_PHASE"
export const LIFECYCLE_MODEL_DRAW_CONNECTION = "LIFECYCLE_MODEL_DRAW_CONNECTION"
export const LIFECYCLE_MODEL_LOAD_STATE = "LIFECYCLE_MODEL_LOAD_STATE"
export const LIFECYCLE_MODEL_RELOAD = "LIFECYCLE_MODEL_RELOAD"


// lifecycle import
export const LIFECYCLE_IMPORT_FROM_LIBRARY_LIST = "LIFECYCLE_IMPORT_FROM_LIBRARY_LIST"
export const LIFECYCLE_IMPORT_FROM_LIBRARY_IDS = "LIFECYCLE_IMPORT_FROM_LIBRARY_IDS"
export const LIFECYCLE_IMPORT_FROM_LIBRARY_SORT = "LIFECYCLE_IMPORT_FROM_LIBRARY_SORT"
export const LIFECYCLE_IMPORT_FROM_LIBRARY_FILTERS = "LIFECYCLE_IMPORT_FROM_LIBRARY_FILTERS"

export const LIFECYCLE_IMPORT_FROM_ACCOUNT_LIST = "LIFECYCLE_IMPORT_FROM_ACCOUNT_LIST"
export const LIFECYCLE_IMPORT_FROM_ACCOUNT_IDS = "LIFECYCLE_IMPORT_FROM_ACCOUNT_IDS"
export const LIFECYCLE_IMPORT_FROM_ACCOUNT_SORT = "LIFECYCLE_IMPORT_FROM_ACCOUNT_SORT"
export const LIFECYCLE_IMPORT_FROM_ACCOUNT_FILTERS = "LIFECYCLE_IMPORT_FROM_ACCOUNT_FILTERS"

export const LIFECYCLE_IMPORT_ID = "LIFECYCLE_IMPORT_ID"
export const LIFECYCLE_RELOAD_IMPORTED = "LIFECYCLE_RELOAD_IMPORTED"
